<template>
  <div id="api-select-container" v-if="isDev">
    <div class="toggle-btn" @click="showToggleApiPopup = true" v-drag v-if="isDev">切换接口</div>
    <van-popup v-model="showToggleApiPopup" position="bottom" @open="handleShow">
      <van-picker
        :default-index="activeIndex"
        show-toolbar
        :columns="apiList"
        @cancel="showToggleApiPopup = false"
        @confirm="submitApiChange"
        confirm-button-text="切换"
        class="api-picker-area"
        ref="api-picker"
        v-if="showToggleApiPopup && isDev"
      >
      <template #option="option">
        <div>{{ option.name }}</div>
      </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  directives: {
    // 拖拽指令
    drag: {
      bind (el, {value}) {
        try {
          el.ontouchstart = function (downEvent) {
            let disX = downEvent.touches[0].pageX - el.offsetLeft
            let disY = downEvent.touches[0].pageY - el.offsetTop
            document.ontouchmove = function (moveEvent) {
              let left = moveEvent.touches[0].pageX - disX
              let maxLeft = window.innerWidth - el.clientWidth
              left >= maxLeft && (left = maxLeft)
              left <= 0 && (left = 0)
              let top = moveEvent.touches[0].pageY - disY
              let maxTop = window.innerHeight - el.clientHeight
              top >= maxTop && (top = maxTop)
              top <= 0 && (top = 0)
              el.style.left = left + 'px'
              el.style.top = top + 'px'
            }
            document.ontouchend = function () {
              document.ontouchmove = document.ontouchend = null
            }
          }
        } catch (error) {
        }
      }
    }
  },
  computed: {
    isDev () {
      return process.env.NODE_ENV === 'development'
    }
  },
  data () {
    return {
      activeIndex: 0,
      showToggleApiPopup: false,
      apiList: [
        {
          value: 'development',
          name: '谢炳卓'
        },
        {
          value: 'test',
          name: '测试'
        }
      ]
    }
  },
  methods: {
    submitApiChange (item) {
      Cookies.set('kf_env', item.value)
      this.showToggleApiPopup = false
      location.reload()
    },
    handleShow () {
      let cookieKfEnv = Cookies.get('kf_env')
      this.activeIndex = this.apiList.findIndex(item => item.value === cookieKfEnv)
    }
  }
}
</script>

<style lang="less" scoped>
#api-select-container{
  font-size: 18px;
  .toggle-btn{
    position: fixed;
    top: 15px;
    right: 0;
    background-color: #67C23A;
    color: #fff;
    height: 30px;
    line-height: 30px;
    z-index: 99;
    font-size: 16px;
    padding: 0 8px;
    border-radius: 8px;
    width: fit-content;
  }
  /deep/.api-picker-area .van-picker-column__item--selected{
    color: #67C23A;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/apiSelect.vue